module.exports = {
  appName: 'ALD | ProFleet',
  calendarColor: 'blue',
  footerLogo: true,
}
